import React, { Component } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Replay as Reload, Add, Delete } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withSnackbar } from "notistack";

import SearchButton from "components/ui/searchbutton/SearchButton";
import ConfirmDialog from "components/ui/confirmdialog/ConfirmDialog";

import UserGroupsGrid from "./UserGroupsGrid";
import DialogAddGroup from "./DialogAddGroup";

import { commonJs } from "common/common";
import { ERRORS, NOTIFY, SUCCESS_MSG } from "common/consts";
import { API_Settings } from "apihandler/Settings";
import { connect } from "react-redux";

class UserGroups extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, popupDialog: false, showDialog: true };
  }

  reloadGrid = () => {
    this._groupListGrid.loadReloadRecords();
  };

  onSearch = (e) => {
    let val = e.target.value.trim();
    this._groupListGrid.onSearch(val);
  };

  togglePopup = (rec) => {
    const { popupDialog } = this.state;
    if (rec.id) {
      let self = this;
      this.setState({
        popupDialog: !popupDialog,
        showDialog: false,
      });
      setTimeout(() => {
        if (self._userGroupDialog) {
          self._userGroupDialog.setData(rec);
        }
        self.setState({
          showDialog: true,
        });
      }, 5000);
    } else {
      this.setState({
        popupDialog: !popupDialog,
        showDialog: true,
      });
    }
  };

  onDeleteRecord = (id, name) => {
    this._confirmDialog.toggleConfirmDialog(id, name);
  };

  onDeleteSuccess = (id) => {
    let self = this;
    if (id) {
      const { uid } = this.props.loginReducer;
      API_Settings.deleteUserGroup({
        userId: uid,
        groupId: id,
      })
        .then((res) => {
          if (res.Result === 200) {
            self._confirmDialog.toggleConfirmDialog("close");
            commonJs.showNotify(
              self.props,
              NOTIFY.SUCCESS,
              SUCCESS_MSG.RECORD_DELETED_SUCCESSFULLY
            );
            self.reloadGrid();
          } else {
            commonJs.showNotify(
              self.props,
              NOTIFY.ERROR,
              ERRORS.RECORD_NOT_DELETED
            );
          }
        })
        .catch((err) => {
          commonJs.showNotify(
            self.props,
            NOTIFY.ERROR,
            ERRORS.RECORD_NOT_DELETED
          );
        });
    }
    console.log("onDeleteSuccess: ", id);
  };

  render() {
    const { loading, popupDialog, showDialog } = this.state;

    return (
      <div id="usersVehiclesListGrid" className="settingsGrid">
        <ul>
          <li className="searchDiv">
            <SearchButton
              id="userGroupSearch"
              placeholder="Search By Group Name"
              buttonClass="pad5 iconButton searchBtn"
              inputClass="SearchInput"
              iconwidth="18"
              iconheight="18"
              onChange={this.onSearch}
            />
          </li>
          <li>
            <Tooltip title="Reload" placement="bottom">
              <IconButton onClick={this.reloadGrid}>
                <Reload />
              </IconButton>
            </Tooltip>
          </li>
          <li title="Add Vehicle">
            <Tooltip title="Add Vehicle" placement="bottom">
              <IconButton onClick={this.togglePopup}>
                <Add />
              </IconButton>
            </Tooltip>
          </li>
          {/* <li>
            <Tooltip title="Delete All Vehicles" placement="bottom">
              <IconButton onClick={() => this.onDeleteRecord("all")}>
                <Delete />
              </IconButton>
            </Tooltip>
          </li> */}
        </ul>

        {!loading ? (
          <UserGroupsGrid
            childRef={(ref) => (this._groupListGrid = ref)}
            togglePopupDialog={this.togglePopup}
            onDeleteRecord={this.onDeleteRecord}
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: window.innerHeight / 1.5,
              alignItems: "center",
            }}
          >
            <p style={{ color: "#a1a1a1", fontSize: 14 }}>Loading...</p>
          </div>
        )}

        {popupDialog && (
          <DialogAddGroup
            childRef={(ref) => (this._userGroupDialog = ref)}
            togglePopup={this.togglePopup}
            reloadGrid={this.reloadGrid}
            showDialog={showDialog}
          />
        )}

        {!showDialog && (
          <div className="popover-loading">
            <CircularProgress className={"primary"} />
          </div>
        )}

        <ConfirmDialog
          childRef={(ref) => (this._confirmDialog = ref)}
          onOk={this.onDeleteSuccess}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginReducer: state.loginReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(UserGroups));
